import React from 'react';

import {CheckboxSkeleton, FormSectionSkeleton} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const PbEditorialSettingsSkeleton = () => (
    <FormSectionSkeleton labelWidth={200}>
        <Group direction="v" alignItems="start">
            <CheckboxSkeleton labelWidth={182}/>
            <CheckboxSkeleton labelWidth={182}/>
        </Group>
    </FormSectionSkeleton>
);
